import React from "react";
import { useTranslation } from 'react-i18next';

interface CompletedSession {
  session_name: string;
  skill_name: string;
  completed_at?: string;
}

interface Props {
  data: {
    completed_sessions: CompletedSession[];
  };
}

export const CompletedSessionsWidget: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined
    });
  };

  // Group by skill
  const bySkill = data.completed_sessions.reduce((acc, session) => {
    if (!acc[session.skill_name]) {
      acc[session.skill_name] = [];
    }
    acc[session.skill_name].push(session);
    return acc;
  }, {} as Record<string, CompletedSession[]>);

  return (
    <div className="bg-card rounded-xl border-2 border-border/50 p-4 mt-2 shadow-sm">
      <h4 className="font-semibold text-foreground mb-3">
        {t('widgets.completedCount', { count: data.completed_sessions.length })}
      </h4>

      <div className="space-y-3">
        {Object.entries(bySkill).map(([skillName, sessions]) => (
          <div key={skillName} className="bg-muted/50 rounded-xl p-3 border border-border/30">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2">
              {skillName}
            </div>
            <ul className="space-y-1">
              {sessions.map((session, idx) => (
                <li key={idx} className="flex justify-between items-center text-sm">
                  <span className="text-foreground">{session.session_name}</span>
                  {session.completed_at && (
                    <span className="text-xs text-muted-foreground">{formatDate(session.completed_at)}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
